export default __webpack_public_path__ + "static/8-ddbbb301734db290aa9a9281ebe1198c.png";